import { Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import { Vue } from 'vue-property-decorator';

@Component({
  components: { DsModal },
})
export default class ScrapAgentAccountConnectDropboxComponent extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @PropSync('channelConnect', { type: Object }) syncedChannelConnect!: any;

  showModal = this.open;
  formData = {
    accountId: String(Math.random() * (100 - 1) + 1),
    accountName: 'hyejin.choi@naver.com',
    password: 'hyejin.choi@naver.com',
  } as any;

  @Watch('open')
  onOpenChange(value: boolean) {
    this.showModal = value;
  }
}
